<script>
  /**
   * Drawer for contextual entry editing
   * Uses BaseDrawer for drawer mechanics and InPlaceEntryEditor for entry editing
   */
  import BaseDrawer from '#lib/BaseDrawer.svelte';
  import InPlaceEntryEditor from '#lib/InPlaceEntryEditor.svelte';
  import t from '#lib/i18n.svelte.js';
  
  let {
    /** @type {string} Entry ID to edit */
    entry_id,
    /** @type {() => void} Callback when drawer closes */
    onclose,
    /** @type {() => void} Callback when entry is saved */
    onsave,
    /** @type {() => void} Callback when editing is cancelled */
    oncancel,
  } = $props();

  let has_unsaved_changes = $state(false);
  let did_save = $state(false);
  let drawer_ref = $state();

  /**
   * Check for unsaved changes before closing
   * @returns {boolean} Whether close should proceed
   */
  function handle_before_close() {
    if (has_unsaved_changes) {
      const message = t('unsaved_changes_warning') || 'You have unsaved changes. Close anyway?';
      return confirm(message);
    }
    return true;
  }

  /**
   * Handle close from drawer
   */
  function handle_close() {
    if (!did_save) {
      oncancel?.();
    }
    onclose?.();
  }

  /**
   * Handle save from editor
   */
  function handle_save() {
    did_save = true;
    onsave?.();
  }

  /**
   * Handle cancel from editor
   */
  function handle_cancel() {
    drawer_ref?.request_close();
  }
</script>

<BaseDrawer 
  bind:this={drawer_ref}
  onclose={handle_close}
  onbeforeclose={handle_before_close}
>
  {#snippet children()}
    <InPlaceEntryEditor 
      {entry_id} 
      bind:has_unsaved_changes 
      onclose={handle_cancel}
      onsave={handle_save}
      oncancel={() => {}}
    />
  {/snippet}
</BaseDrawer>
